<template>
  <!-- #region template -->
  <b-form-select v-if="!busy" @change="handleInput" autocomplete="off" v-model="_value" :options="options" :multiple="element.multiple" :select-size="element['select-size']" :required="element.required"></b-form-select>
  <!-- #endregion -->
</template>

<script>
// #region script
// #region import
import { mapActions } from 'vuex'
// #endregion

// #region export
export default {
  name: 'eSelect',
  props: {
    value: {
      type: String,
      required: true,
    },
    element: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.update()
  },
  data() {
    return {
      busy: true,
      _value: null,
      options: [],
    }
  },
  methods: {
    ...mapActions(['firestore/getDocs']),
    /**
     * Updates the available options.
     */
    update() {
      this.busy = true
      if (this.element.collection) {
        this['firestore/getDocs']({
          path: this.element.collection,
        }).then((documents) => {
          this.options = documents.map((document) => {
            return {
              value: document._reference.path,
              text: document.name,
            }
          })
          this._value = this.value
          this.busy = false
        })
      } else {
        this.options = this.element.options
        this._value = this.value
        this.busy = false
      }
    },
    /**
     * Fired when an update to the element is made. Emits the changes to the form.
     */
    handleInput() {
      this.$emit('input', this._value)
    },
  },
}
// #endregion
// #endregion
</script>
